import { useSelector } from 'react-redux';

import AcrisRealPropertyMasterModal from 'modals/AcrisRealPropertyMasterModal';
import UserAdminEditModal from 'modals/UserAdminEditModal';
import UserAdminCreateModal from 'modals/UserAdminCreateModal';
import AddToCartModal from 'modals/AddToCartModal';
import CalendarEventModal from 'modals/CalendarEventModal';
import ConfirmModal from 'modals/ConfirmModal';
import DataTableModal from 'modals/DataTableModal';
import DocumentRequestModal from 'modals/DocumentRequestModal';
import ECBInfractionCodeModal from 'modals/ECBInfractionCodeModal';
import ExportEmailModal from 'modals/ExportEmailModal';
import ExportReportModal from 'modals/ExportReportModal';
import FDNYReportModal from 'modals/FDNYReportModal';
import GetStartedModal from 'modals/GetStartedModal';
import HistoricDocumentRequestModal from 'modals/HistoricDocumentRequestModal';
import IframeModal from 'modals/IframeModal';
import ImageModal from 'modals/ImageModal';
import MissingPropertyReportModal from 'modals/MissingPropertyReportModal';
import OwnersModal from 'modals/OwnersModal';
import PropertyFileUploadModal from 'modals/PropertyFileUploadModal';
import PropertyNotificationsModal from 'modals/PropertyNotificationsModal';
import RecordDetailsModal from 'modals/RecordDetailsModal';
import SanbornInfoModal from 'modals/SanbornInfoModal';
import SpecialDistrictsModal from 'modals/SpecialDistrictsModal';
import SubscriptionActionModal from 'modals/SubscriptionActionModal.jsx';
import SubscriptionExceedLimitModal from 'modals/SubscriptionExceedLimitModal.jsx';
import SubscriptionCreateModal from 'modals/SubscriptionCreateModal.jsx';
import UploadModal from 'modals/UploadModal';
import AddPortfolioModal from 'modals/AddPortfolioModal.jsx';
import AddPortfolioUserModal from 'modals/AddPortfolioUserModal.jsx';
import AddPortfolioPropertyModal from 'modals/AddPortfolioPropertyModal.jsx';
import PortfolioUserViewModal from 'modals/PortfolioUserViewModal.jsx';
import SelectPortfolioModal from 'modals/SelectPortfolioModal.jsx';
import UpgradeIncentiveModal from 'modals/UpgradeIncentiveModal.jsx';
import EnterpriseOnboardingModal from 'modals/EnterpriseOnboardingModal.jsx';
import FreeTrialOnboardingModal from 'modals/FreeTrialOnboardingModal.jsx';

import 'modals/Modal.css';
import PropertyStatsModal from './pages/_rd_dashboard/QueueMonitor/PropertyStatsModal';
import DatasetDrawer from './pages/_rd_dashboard/DatasetMonitor/components/DatasetDrawer';
import DatasetHealthLegend from './pages/_rd_dashboard/DatasetMonitor/components/DatasetHealthLegend';
import AddOrganizationModal from './modals/Organization/AddOrganizationModal';
import AddOrganizationMemberModal from 'modals/Organization/AddOrganizationMemberModal';
import UpdateOrganizationMemberModal from 'modals/Organization/UpdateOrganizationMemberModal';
import AcceptInvitationModal from 'modals/Organization/AcceptInvitationModal';
import AirtableSyncModal from './pages/_rd_dashboard/AirtableSyncModal';
import CertificatesOfOccupancyModal from './modals/CertificatesOfOccupancy';
import HpdICardsModal from './modals/HpdICards';

export const MODAL_TYPES = {
	ACRIS_REAL_PROPERTY_MASTER: 'ACRIS_REAL_PROPERTY_MASTER',
	ADD_TO_CART: 'ADD_TO_CART',
	CALENDAR_EVENT: 'CALENDAR_EVENT',
	CONFIRM: 'CONFIRM',
	DATA_TABLE: 'DATA_TABLE',
	DOCUMENT_REQUEST: 'DOCUMENT_REQUEST',
	ECB_INFRACTION_CODE: 'ECB_INFRACTION_CODE',
	EMAIL_EXPORT_REPORT: 'EMAIL_EXPORT_REPORT',
	EXPORT_REPORT: 'EXPORT_REPORT',
	FDNY_REPORT: 'FDNY_REPORT',
	GET_STARTED: 'GET_STARTED',
	HISTORIC_DOCUMENT_REQUEST: 'HISTORIC_DOCUMENT_REQUEST',
	IFRAME: 'IFRAME',
	IMAGE: 'IMAGE',
	MISSING_PROPERTY_REPORT: 'MISSING_PROPERTY_REPORT',
	OWNERS: 'OWNERS',
	PROPERTY_FILE_UPLOAD_MODAL: 'PROPERTY_FILE_UPLOAD_MODAL',
	PROPERTY_NOTIFICATION_MODAL: 'PROPERTY_NOTIFICATION_MODAL',
	RECORD_DETAILS: 'RECORD_DETAILS',
	SANBORN_INFO: 'SANBORN_INFO',
	SPECIAL_DISTRICTS: 'SPECIAL_DISTRICTS',
	SUBSCRIPTION_ACTION: 'SUBSCRIPTION_ACTION',
	SUBSCRIPTION_EXCEED_LIMIT: 'SUBSCRIPTION_EXCEED_LIMIT',
	SUBSCRIPTION_CREATE: 'SUBSCRIPTION_CREATE',
	UPLOAD: 'UPLOAD',
	USER_ADMIN_CREATE: 'USER_ADMIN_CREATE',
	USER_ADMIN_EDIT: 'USER_ADMIN_EDIT',
	ADD_PORTFOLIO_MODAL: 'ADD_PORTFOLIO_MODAL',
	EDIT_PORTFOLIO_MODAL: 'EDIT_PORTFOLIO_MODAL',
	ADD_PORTFOLIO_USER_MODAL: 'ADD_PORTFOLIO_USER_MODAL',
	ADD_PORTFOLIO_PROPERTY_MODAL: 'ADD_PORTFOLIO_PROPERTY_MODAL',
	PORTFOLIO_USER_VIEW_MODAL: 'PORTFOLIO_USER_VIEW_MODAL',
	SELECT_PORTFOLIO: 'SELECT_PORTFOLIO',
	UPGRADE_INCENTIVE: 'UPGRADE_INCENTIVE',
	ENTERPRISE_ONBOARDING: 'ENTERPRISE_ONBOARDING',
	FREE_TRIAL_ONBOARDING: 'FREE_TRIAL_ONBOARDING',
	PROPERTY_STATS: 'PROPERTY_STATS',
	DATASET_DRAWER: 'DATASET_DRAWER',
	DATASET_HEALTH_LEGEND: 'DATASET_HEALTH_LEGEND',
	EDIT_ORGANIZATION: 'EDIT_ORGANIZATION',
	ADD_ORGANIZATION_MEMBER: 'ADD_ORGANIZATION_MEMBER',
	UPDATE_ORGANIZATION_MEMBER: 'UPDATE_ORGANIZATION_MEMBER',
	ACCEPT_INVITATION: 'ACCEPT_INVITATION',
	AIRTABLE_SYNC: 'AIRTABLE_SYNC',
	CERTIFICATES_OF_OCCUPANCY: 'CERTIFICATES_OF_OCCUPANCY',
	HPD_I_CARDS: 'HPD_I_CARDS',
};

const ModalManager = (props) => {
	const { currentModal, isOpen, modalOptions } = useSelector((state) => ({
		currentModal: state.modal.currentModal,
		isOpen: state.modal.isOpen,
		modalOptions: state.modal.modalOptions,
	}));

	if (isOpen && currentModal) {
		switch (currentModal) {
			case MODAL_TYPES.ACRIS_REAL_PROPERTY_MASTER:
				return <AcrisRealPropertyMasterModal options={modalOptions} />;
			case MODAL_TYPES.ADD_TO_CART:
				return <AddToCartModal options={modalOptions} />;
			case MODAL_TYPES.CALENDAR_EVENT:
				return <CalendarEventModal options={modalOptions} />;
			case MODAL_TYPES.CONFIRM:
				return <ConfirmModal options={modalOptions} />;
			case MODAL_TYPES.DATA_TABLE:
				return <DataTableModal options={modalOptions} />;
			case MODAL_TYPES.DOCUMENT_REQUEST:
				return <DocumentRequestModal options={modalOptions} />;
			case MODAL_TYPES.ECB_INFRACTION_CODE:
				return <ECBInfractionCodeModal options={modalOptions} />;
			case MODAL_TYPES.EMAIL_EXPORT_REPORT:
				return <ExportEmailModal options={modalOptions} />;
			case MODAL_TYPES.EXPORT_REPORT:
				return <ExportReportModal options={modalOptions} />;
			case MODAL_TYPES.FDNY_REPORT:
				return <FDNYReportModal options={modalOptions} />;
			case MODAL_TYPES.GET_STARTED:
				return <GetStartedModal options={modalOptions} />;
			case MODAL_TYPES.HISTORIC_DOCUMENT_REQUEST:
				return <HistoricDocumentRequestModal options={modalOptions} />;
			case MODAL_TYPES.IFRAME:
				return <IframeModal options={modalOptions} />;
			case MODAL_TYPES.IMAGE:
				return <ImageModal options={modalOptions} />;
			case MODAL_TYPES.MISSING_PROPERTY_REPORT:
				return <MissingPropertyReportModal options={modalOptions} />;
			case MODAL_TYPES.OWNERS:
				return <OwnersModal options={modalOptions} />;
			case MODAL_TYPES.PROPERTY_FILE_UPLOAD_MODAL:
				return <PropertyFileUploadModal options={modalOptions} />;
			case MODAL_TYPES.PROPERTY_NOTIFICATION_MODAL:
				return <PropertyNotificationsModal options={modalOptions} />;
			case MODAL_TYPES.RECORD_DETAILS:
				return <RecordDetailsModal options={modalOptions} />;
			case MODAL_TYPES.SANBORN_INFO:
				return <SanbornInfoModal options={modalOptions} />;
			case MODAL_TYPES.SPECIAL_DISTRICTS:
				return <SpecialDistrictsModal options={modalOptions} />;
			case MODAL_TYPES.SUBSCRIPTION_ACTION:
				return <SubscriptionActionModal options={modalOptions} />;
			case MODAL_TYPES.SUBSCRIPTION_EXCEED_LIMIT:
				return <SubscriptionExceedLimitModal options={modalOptions} />;
			case MODAL_TYPES.SUBSCRIPTION_CREATE:
				return <SubscriptionCreateModal options={modalOptions} />;
			case MODAL_TYPES.UPLOAD:
				return <UploadModal options={modalOptions} />;
			case MODAL_TYPES.USER_ADMIN_CREATE:
				return <UserAdminCreateModal options={modalOptions} />;
			case MODAL_TYPES.USER_ADMIN_EDIT:
				return <UserAdminEditModal options={modalOptions} />;
			case MODAL_TYPES.ADD_PORTFOLIO_MODAL:
				return <AddPortfolioModal options={modalOptions} />;
			case MODAL_TYPES.EDIT_PORTFOLIO_MODAL:
				return <AddPortfolioModal options={modalOptions} />; // Reuse for now
			case MODAL_TYPES.ADD_PORTFOLIO_USER_MODAL:
				return <AddPortfolioUserModal options={modalOptions} />;
			case MODAL_TYPES.ADD_PORTFOLIO_PROPERTY_MODAL:
				return <AddPortfolioPropertyModal options={modalOptions} />;
			case MODAL_TYPES.PORTFOLIO_USER_VIEW_MODAL:
				return <PortfolioUserViewModal options={modalOptions} />;
			case MODAL_TYPES.SELECT_PORTFOLIO:
				return <SelectPortfolioModal options={modalOptions} />;
			case MODAL_TYPES.UPGRADE_INCENTIVE:
				return <UpgradeIncentiveModal options={modalOptions} />;
			case MODAL_TYPES.ENTERPRISE_ONBOARDING:
				return <EnterpriseOnboardingModal options={modalOptions} />;
			case MODAL_TYPES.FREE_TRIAL_ONBOARDING:
				return <FreeTrialOnboardingModal options={modalOptions} />;
			case MODAL_TYPES.PROPERTY_STATS:
				return <PropertyStatsModal options={modalOptions} />;
			case MODAL_TYPES.DATASET_DRAWER:
				return <DatasetDrawer options={modalOptions} />;
			case MODAL_TYPES.DATASET_HEALTH_LEGEND:
				return <DatasetHealthLegend />;
			case MODAL_TYPES.EDIT_ORGANIZATION:
				return <AddOrganizationModal options={modalOptions} />;
			case MODAL_TYPES.ADD_ORGANIZATION_MEMBER:
				return <AddOrganizationMemberModal options={modalOptions} />;
			case MODAL_TYPES.UPDATE_ORGANIZATION_MEMBER:
				return <UpdateOrganizationMemberModal options={modalOptions} />;
			case MODAL_TYPES.ACCEPT_INVITATION:
				return <AcceptInvitationModal options={modalOptions} />;

			case MODAL_TYPES.AIRTABLE_SYNC:
				return <AirtableSyncModal options={modalOptions} />;
			case MODAL_TYPES.CERTIFICATES_OF_OCCUPANCY:
				return <CertificatesOfOccupancyModal options={modalOptions} />;
			case MODAL_TYPES.HPD_I_CARDS:
				return <HpdICardsModal options={modalOptions} />;

			default:
				return null;
		}
	}

	return null;
};

export default ModalManager;
